import { panelStyle } from '../constants';
import { HelpCaption } from './captions/help-caption';
import { SupportTitle } from './captions/support-title';
import { HelpCenterCollapsiblePanel } from './collapse/help-center-collapsible-panel';

// TODO: JSDoc
// panelItems example
// {
//     key: "1",
//     label: (
//         <CollapsePanelTitle>(section label)</CollapsePanelTitle>
//     ),
//     children: (playerComponent),
// },
export const HelpCenterContent = ({ helpCaptionTitle = 'Title', panelItems = [], defaultActiveKey = ['1'] }) => {
  return (
    <div className="d-flex flex-direction-column">
      <SupportTitle />
      <HelpCaption>{helpCaptionTitle}</HelpCaption>
      <HelpCenterCollapsiblePanel
        defaultActiveKey={defaultActiveKey}
        items={panelItems.map((value) => ({ ...value, style: panelStyle }))}
      />
    </div>
  );
};
